<template>
  <EInstantAnswer
    class="flights"
    data-test-id="flights"
    :feedback-link="{
      ticketSubject: 'Search - Flights',
      widgetType: 'flights_rich'
    }"
    :sr-title="$t('web.widgets.flights.title')"
    overflow-visible
  >
    <div class="flights__content">
      <div
        class="flights__placeholder"
        v-bind="locationAttrs"
        :data-locale="language"
        :data-market="bingMarketCode"
        :data-currency="currency"
        :data-flight-outbound-date="outboundDate"
        data-associate-id="API_B2B_18622_00002"
        data-skyscanner-widget="SearchWidget"
        data-powered-by-size="0"
        data-responsive="true"
        data-enable-placeholders="true"
        data-target="_blank"
        data-multi-city-max-flights-number="0"
        data-flights-max-adults-number="0"
        data-flights-max-children-number="0"
        data-test-id="placeholder"
      >
        <ELoading />
      </div>
      <script async type="application/javascript" src="https://widgets.skyscanner.net/widget-server/js/loader.js" />
    </div>
    <template #footer-left>
      <svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 1600 259.36" class="flights__logo"><g fill="#396fc0"><path d="M175.867 222.053a20.878 20.878 0 0010.472-2.81l38.441-22.192a41.903 41.903 0 0125.692-5.347c46.708 5.383 79.54 14.21 89.212 17.024a5.158 5.158 0 005.47-1.724c1.582-1.97 3.603-5.117 5.046-9.637 1.441-4.448 1.635-8.123 1.495-10.656-.106-2.18-1.6-4.046-3.694-4.66-15.158-4.467-82.132-22.598-172.134-22.598-90.003 0-156.977 18.131-172.136 22.598-2.092.614-3.587 2.48-3.692 4.66-.141 2.533.052 6.208 1.494 10.656 1.443 4.52 3.464 7.668 5.047 9.637a5.157 5.157 0 005.47 1.724c9.671-2.813 42.503-11.641 89.21-17.024a41.904 41.904 0 0125.693 5.347l38.442 22.193a20.878 20.878 0 0010.472 2.81M111.66 97.301a15.252 15.252 0 009.29 7.128 15.253 15.253 0 0011.61-1.528 15.254 15.254 0 007.128-9.289 15.253 15.253 0 00-1.528-11.61L103.57 22.09c-1.109-1.92-3.268-2.701-5.487-2.538-2.734.218-6.63 1.634-11.184 4.264-4.553 2.628-7.728 5.296-9.284 7.553-1.251 1.84-1.652 4.101-.545 6.02l34.59 59.913M79.958 140.203a15.24 15.24 0 0011.61 1.529 15.25 15.25 0 009.29-7.128 15.253 15.253 0 001.528-11.61 15.255 15.255 0 00-7.129-9.29l-59.913-34.59c-1.919-1.109-4.18-.706-6.02.545-2.257 1.556-4.925 4.73-7.553 9.284-2.63 4.554-4.045 8.45-4.264 11.184-.163 2.218.619 4.378 2.538 5.486l59.913 34.59M191.167 76.028c0 4.224-1.714 8.048-4.482 10.817a15.252 15.252 0 01-10.818 4.482 15.25 15.25 0 01-10.819-4.482 15.255 15.255 0 01-4.481-10.817V6.845c0-2.214 1.478-3.972 3.482-4.941C166.527.728 170.61.005 175.867.005s9.34.723 11.817 1.899c2.004.97 3.483 2.727 3.483 4.941v69.183M240.072 97.301a15.25 15.25 0 01-9.29 7.128 15.253 15.253 0 01-11.609-1.528 15.25 15.25 0 01-7.128-9.289 15.247 15.247 0 011.528-11.61l34.591-59.913c1.108-1.92 3.267-2.701 5.487-2.538 2.733.218 6.629 1.634 11.182 4.264 4.555 2.628 7.728 5.296 9.286 7.553 1.25 1.84 1.652 4.101.545 6.02l-34.592 59.913M271.776 140.203a15.242 15.242 0 01-11.61 1.529 15.248 15.248 0 01-9.29-7.128 15.247 15.247 0 01-1.528-11.61 15.253 15.253 0 017.128-9.29l59.913-34.59c1.919-1.109 4.18-.706 6.02.545 2.258 1.556 4.924 4.73 7.554 9.284 2.629 4.554 4.044 8.45 4.264 11.184.162 2.218-.62 4.378-2.539 5.486l-59.912 34.59M654.195 92.655h28.792c1.057 0 2.005.648 2.389 1.632l28.708 73.557 27.844-73.532a2.564 2.564 0 012.399-1.657h28.28c1.848 0 3.089 1.896 2.35 3.59l-70.425 161.492a2.564 2.564 0 01-2.341 1.54l-24.918.083c-1.842.007-3.09-1.876-2.368-3.57l24.032-56.382-47.076-103.124c-.776-1.697.466-3.63 2.334-3.63M1017.133 149.69c0 19.705 12.202 34.873 31.611 34.873 19.408 0 32.061-13.108 32.061-33.41 0-20.303-12.212-35.774-32.849-35.774-19.513 0-30.823 15.235-30.823 34.312zm62.884-40.723V95.22a2.565 2.565 0 012.566-2.565h25.468a2.565 2.565 0 012.565 2.565v109.503a2.565 2.565 0 01-2.565 2.565h-25.468a2.565 2.565 0 01-2.566-2.565V190.3c-5.453 8.454-17.441 19.46-36.898 19.46-37.315 0-56.698-28.445-56.698-60.296 0-41.465 28.799-59.285 55.798-59.285 17.732 0 30.066 8.357 37.798 18.787M1133.728 204.723V95.22a2.565 2.565 0 012.565-2.565h25.468a2.565 2.565 0 012.566 2.565v14.87c6.066-10.443 17.198-19.91 36.336-19.91 19.733 0 41.624 9.695 41.624 54.223v60.32a2.565 2.565 0 01-2.566 2.565h-25.469a2.564 2.564 0 01-2.564-2.565v-59.87c0-10.748-2.643-29.137-21.712-29.137-19.07 0-25.65 16.706-25.65 32.173v56.834a2.565 2.565 0 01-2.565 2.565h-25.468a2.565 2.565 0 01-2.565-2.565M1264.495 204.723V95.22a2.564 2.564 0 012.564-2.565h25.469a2.564 2.564 0 012.564 2.565l.001 14.87c6.066-10.443 17.198-19.91 36.336-19.91 19.731 0 41.624 9.695 41.624 54.223v60.32a2.563 2.563 0 01-2.56 2.565h-25.48a2.563 2.563 0 01-2.56-2.565v-59.87c0-10.748-2.64-29.137-21.71-29.137s-25.65 16.706-25.65 32.173l-.001 56.834a2.564 2.564 0 01-2.564 2.565h-25.47a2.564 2.564 0 01-2.563-2.565M1532.253 92.655h24.8a2.563 2.563 0 012.56 2.565v22.633c5-22.506 24.254-30.164 38.4-26.965a2.556 2.556 0 011.987 2.505v24.988c0 1.622-1.493 2.822-3.08 2.51-26.067-5.107-36.627 8.923-36.627 28.686v55.152a2.56 2.56 0 01-2.573 2.56h-25.467a2.563 2.563 0 01-2.56-2.566V95.22a2.563 2.563 0 012.56-2.565M485.21 117.508l-18.478-6.399c-6.43-2.226-17.525-8.609-17.525-18.896 0-10.286 7.106-16.658 21.262-16.658 13.064 0 20.276 6.39 24.974 16.516.638 1.377 2.304 1.928 3.618 1.169l20.918-12.077a2.564 2.564 0 001.062-3.275c-6.312-13.912-21.038-30.568-50.29-30.568-32.602 0-52.926 19.388-52.926 44.772 0 25.384 16.756 38.547 39.392 46.247l18.634 6.338c13.324 4.532 19.478 10.532 19.478 18.874 0 8.342-5.205 18.088-26.042 18.088-18.984 0-25.742-10.035-29.515-19.608-.57-1.45-2.308-2.04-3.657-1.26l-21.9 12.644a2.582 2.582 0 00-1.098 3.198c8.359 20.832 31.436 33.149 57.408 33.149 30.411 0 56.079-15.54 56.079-46.786 0-31.248-33.547-42.752-41.393-45.468M653.216 177.384c-.759-1.312-2.49-1.69-3.715-.796-9.865 7.194-21.534 7.337-30.208-6.223L603.02 144.92l38.608-48.095c1.348-1.678.152-4.17-2-4.17h-30.212c-.82 0-1.59.392-2.073 1.054l-33.424 45.892V47.184a2.564 2.564 0 00-2.564-2.564h-25.47a2.565 2.565 0 00-2.565 2.564v157.539a2.564 2.564 0 002.565 2.564h25.47a2.563 2.563 0 002.564-2.564v-51.208s17.118 26.962 23.478 36.982c8.723 13.742 21.183 19.265 34.419 19.265 12.62 0 20.735-3.394 30.452-12.786a2.577 2.577 0 00.447-3.139l-9.499-16.453M836.155 141.03c-8.147-3.011-10.94-4.045-17.144-6.337-6.206-2.293-11.547-5.602-11.547-10.556 0-4.952 4.524-10.446 13.837-10.446 8.131 0 13.094 3.244 15.824 8.801a2.561 2.561 0 003.58 1.1l17.9-10.335a2.567 2.567 0 00.942-3.504c-4.9-8.532-14.655-19.573-38.02-19.573-28.696 0-43.424 16.58-43.424 34.873s14.985 26.915 28.686 32.446l18.426 7.441c4.781 1.93 10.485 4.91 10.485 10.43 0 5.522-6.25 10.318-16.087 10.318-9.054 0-19.169-3.692-23.352-14.038a2.562 2.562 0 00-3.657-1.271l-18.056 10.425a2.568 2.568 0 00-1.117 3.15c5.338 13.694 20.984 25.808 46.182 25.808 27.427 0 45.674-14.649 45.674-35.211 0-20.563-13.679-27.81-29.132-33.522M939.296 117.628c11.413 0 19.921 3.463 27.745 9.166 1.238.903 2.982.551 3.747-.775l10.516-18.214a2.573 2.573 0 00-.795-3.417c-10.924-7.377-24.396-14.208-42.676-14.208-18.028 0-34.86 4.992-46.856 16.987-11.994 11.994-17.492 26.185-17.492 43.086 0 20.444 8.387 33.36 17.606 42.579 9.218 9.219 25.684 16.818 46.742 16.818 19.019 0 33.143-7.837 42.658-14.293a2.56 2.56 0 00.772-3.402l-10.446-18.092c-.757-1.313-2.494-1.703-3.714-.801-6.775 5.008-16.668 9.138-27.807 9.138-12.433 0-35.1-7.113-35.1-32.285 0-25.171 22.563-32.287 35.1-32.287M1451.707 114.817c14.626 0 28.013 8.787 30.04 24.636h-61.307c3.973-17.186 16.653-24.636 31.267-24.636zm4.96 69.522c-10.267 0-19.907-2.382-26.947-8.044-7.04-5.662-10.293-11.418-10.293-18.28h91.12c1.44 0 2.586-1.192 2.56-2.633-.534-27.071-9.294-39.82-17.8-48.327-8.787-8.779-23.774-16.875-43.374-16.875-19.586 0-34.88 7.21-45.106 17.437-10.227 10.226-17.88 23.15-17.88 42.86 0 19.711 7.933 32.636 17.653 42.355 9.72 9.718 25.467 16.926 48.133 16.926 21.547 0 39.494-7.608 52.6-22.484 1.067-1.214.747-3.11-.653-3.918l-18.147-10.48c-.96-.552-2.173-.44-2.986.304-9.174 8.376-20.654 11.159-28.88 11.159" /></g></svg>
    </template>
  </EInstantAnswer>
</template>

<script>
import { mapState } from 'vuex';

import ELoading from '~~/common/vue/components/loading';
import getCurrencyForMarket from '~~/common/js/universal/currency';
import EInstantAnswer from '~/components/instant-answers/base/legacy';
import { trackImpression, PAGE_SERP, TYPE_WIDGET } from '~~/search/common/js/client/analytics/rich-content';

const OUTBOUND_OFFSET_DAYS = 4;
const ORIGIN_KEYWORD = 'from';
const DESTINATION_KEYWORD = 'to';

const skyscannerLanguageMap = {
  en: 'en-US',
  de: 'de-DE',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  sv: 'sv-SE',
};

const wordAfter = (keyword) => (word, index, words) => words[index - 1] === keyword;

export default {
  name: 'EFlights',
  components: {
    EInstantAnswer,
    ELoading,
  },
  computed: {
    ...mapState('global', ['locale']),
    ...mapState('user', ['bingMarketCode']),
    language() {
      return skyscannerLanguageMap[this.locale];
    },
    currency() {
      return getCurrencyForMarket(this.bingMarketCode);
    },
    outboundDate() {
      const now = new Date();
      now.setDate(now.getDate() + OUTBOUND_OFFSET_DAYS);
      return now.toISOString();
    },
    locations() {
      const words = (this.$route.query.q?.toString() ?? '').split(' ');
      const origin = words.find(wordAfter(ORIGIN_KEYWORD));
      const destination = words.find(wordAfter(DESTINATION_KEYWORD));
      return { origin, destination };
    },
    locationAttrs() {
      const { origin, destination } = this.locations;
      const attrs = {};

      if (origin) {
        // Skyscanner expects single quotes in the data attribute
        attrs['data-origin-name'] = `'${origin}'`;
      } else {
        attrs['data-origin-geo-lookup'] = true;
      }

      if (destination) {
        attrs['data-destination-name'] = `'${destination}'`;
      }

      return attrs;
    },
  },
  mounted() {
    trackImpression({
      name: 'flights',
      page: PAGE_SERP,
      type: TYPE_WIDGET,
    });
  },
};
</script>

<style lang="scss" scoped>
.flights {
  @include desktop {
    margin: $space-m 0;
  }
}

.flights__content {
  min-height: $space-4l;
}

.flights__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flights__logo {
  align-self: center;
}
</style>

<style lang="scss">
.skyscanner-search-widget {
  a.bpk-button {
    background: var(--color-button-background-secondary) !important;
    border-radius: $border-radius-full;
    border: solid $border-width var(--color-button-border) !important;
    display: flex;
    font-size: $font-m;
    font-weight: $font-weight-m;
    // value to align with input fields, for which Skyscanner uses !important
    height: 2.25rem !important;
    margin: 0 !important;
    padding: 0 $space-2l 0 !important;
    transition: all $timing-1s $easing;
    width: 100%;
    justify-content: center;

    span {
      color: var(--color-button-content-secondary) !important;
      font-family: $family !important;
      margin-right: 0;
      transition: all $timing-1s $easing;
    }

    span + span {
      display: none;
    }

    &:hover {
      background: var(--color-button-background-secondary-hover) !important;
      opacity: 1 !important;

      span {
        color: var(--color-button-content-secondary) !important;
      }
    }

    .ReferralButton__buttonContent___2Gj9d {
      display: inline-flex;
    }
  }

  input {
    $input-padding: $space-s + $space-2s;

    border-color: var(--color-form-border-default) !important;
    border-radius: $border-radius-full !important;
    font-family: $family !important;
    font-size: inherit !important;
    font-weight: normal;
    height: $space-3l !important;
    padding: $input-padding $space-s $input-padding;

    &::placeholder {
      color: var(--color-text-secondary);
      font-size: inherit;
      font-style: normal !important;
    }

    &:hover {
      border-color: var(--color-form-border-hover) !important;
    }

    &:focus {
      border-color: var(--color-form-border-primary-active) !important;
      outline: none;
    }

    + div {
      right: $space-s;
    }
  }

  .SearchWidget__searchWidgetFieldsWrap___29dpH {
    justify-content: center;
  }

  .SearchWidget__searchWidgetField___2_9jt {
    flex-basis: percentage(2/3) !important;
  }

  .SearchWidget__searchWidgetFieldPadded___3F52D:nth-of-type(2) {
    padding-right: 0 !important;
  }

  .CrisisMessage__crisisMessageContainer___2me-A {
    display: none;
  }
}

.PopupDatePicker__datePickerInputContainer___YlGvT {
  &:focus-within {
    svg {
      fill: var(--color-form-border-primary-active);
    }
  }
}

.PopupDatePicker__datePickerInputIcon___18rL6,
.PopupDatePicker__datePickerInputClear___3-STu {
  height: 100%;
  right: $space-s;
}

/**
* [3RD PARTY]
*
* Hide the default icons
*
*/
.datepicker-container {
  .left,
  .right {
    @include elevation(2);

    border-radius: $border-radius-l;
    top: $space-4l;

    &::before {
      display: none;
    }
  }
}

/**
* [3RD PARTY]
*
* Autocomplete
*
*/
.autosuggest-container {
  [role="combobox"] + div {
    width: auto !important;
  }

  ul[role="listbox"] {
    @include elevation(2);

    border-radius: $border-radius-l;

    li {
      & > div {
        align-items: flex-start;
        flex-direction: column;
      }
    }
  }
}

/**
* [3RD PARTY]
*
* Calendar
*
*/
.rdr-Calendar {
  font-family: $family;

  & + a {
    display: none;
  }

  .rdr-MonthAndYear-divider {
    color: var(--color-text-tertiary);
  }

  .rdr-MonthAndYear-innerWrapper {
    padding: 0 !important;
  }

  .rdr-MonthAndYear-month,
  .rdr-MonthAndYear-year {
    font-size: $font-l;
    line-height: $line-height-s;
  }

  .rdr-WeekDays {
    border-bottom: $border-width solid var(--color-decorative-border-1);
    margin-bottom: $space-1s;
  }

  .rdr-WeekDay {
    color: var(--color-text-secondary);
    font-size: $font-s !important;
    font-weight: normal !important;
  }

  .rdr-Day {
    font-size: $font-m !important;
    font-weight: normal !important;

    &.is-passive {
      color: var(--color-text-secondary);
    }

    &.is-selected {
      background: var(--color-background-tertiary) !important;
    }

    &:not(.is-selected):hover {
      background: var(--color-background-secondary) !important;
    }

    &:not(.is-selected):active {
      color: var(--color-text-secondary) !important;
      background: var(--color-background-tertiary) !important;
    }
  }

  .rdr-MonthAndYear-button {
    height: $space-1l !important;
    margin: 0 !important;
    width: $space-1l !important;

    i {
      // since we can only "insert" this icon using CSS
      // and the SVG is fairly small
      // the simplest way is to convert the SVG to a data URI background image.
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%239b9b9b' fill-rule='evenodd' d='M15.587 11.001L12.763 8.14a1 1 0 0 1 1.424-1.404l4.548 4.61a1 1 0 0 1-.007 1.412l-4.548 4.516a1 1 0 1 1-1.41-1.42l2.873-2.852H5.977a1 1 0 1 1 0-2h9.61z'/%3E%3C/svg%3E");
      border: 0 !important;
      height: $space-1l !important;
      width: $space-1l !important;
    }

    &.next i {
      border-color: transparent !important;
    }

    &.prev i {
      border-color: transparent !important;
      transform: rotate(180deg);
    }
  }
}

.CrisisMessage__crisisMessageContainer___2me-A a,
.bpk-button--link {
  font-size: $font-m !important;
  color: var(--color-link-results-default) !important;
  margin: 0 !important;
  padding: 0 !important;

  &:hover {
    text-decoration: underline !important;
  }
}
</style>
